function Frase() {
    return(
        <div>Este é um componente com uma frase!</div>
    )
}
export default Frase